import classnames from "classnames";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import Customizer from "../components/@vuexy/customizer/customizer";
import {
  changeFooterType,
  changeMenuColor,
  changeMode,
  changeNavbarColor,
  changeNavbarType,
  collapseSidebar,
  hideScrollToTop,
} from "../redux/actions/customizer/index";
import Footer from "./components/footer/footer";
import Sidebar from "./components/menu/vertical-menu/sidebar";
import Navbar from "./components/navbar/navbar";

/**
 * VerticalLayout class represents a React component for a vertical layout design.
 * This component manages the layout state, including sidebar visibility, theme customization,
 * and handling user interactions. It integrates with the Customizer component to allow users
 * to customize the theme, navbar, footer, and other layout elements.
 *
 * Attributes:
 *   - width: number - The width of the window
 *   - sidebarState: boolean - The state of the sidebar (collapsed or expanded)
 *   - collapsedContent: boolean - The state of the collapsed content
 *   - sidebarHidden: boolean - The visibility state of the sidebar
 *   - currentLang: string - The current language setting
 *   - appOverlay: boolean - The state of the app overlay
 *
 * Methods:
 *   - updateWidth(): Updates the width state based on the window inner width
 *   - handleCustomizer(bool): Handles the customizer state based on the boolean value
 *   - handleCollapsedMenuPaths(item): Handles the collapsed menu paths based on the item
 *   - toggleSidebarMenu(val): Toggles the sidebar menu state based on the value
 *   - sidebarMenuHover(val): Sets the sidebar state based on the hover value
 *   - handleSidebarVisibility(): Handles the visibility of the sidebar
 *   - handleCurrentLanguage(lang): Handles the current language setting
 *   - handleAppOverlay(value): Handles the app overlay state based on the value
 *   - handleAppOverlayClick(): Handles the click event on the app overlay
 *
 * Lifecycle Methods:
 *   - componentDidMount(): Initializes the component state and event listeners
 *   - componentDidUpdate(prevProps, prevState): Handles updates to props and state changes
 *   - componentWillUnmount(): Cleans up event listeners and resets component state
 *
 * @extends PureComponent
 */
class VerticalLayout extends PureComponent {
  state = {
    width: window.innerWidth,
    sidebarState: this.props.app?.customizer.sidebarCollapsed,
    collapsedContent: this.props.app?.customizer.sidebarCollapsed,
    sidebarHidden: false,
    currentLang: "en",
    appOverlay: false,
    customizer: false,
  };
  collapsedPaths = [];
  mounted = false;

  updateWidth = () => {
    if (this.mounted) {
      this.setState((prevState) => ({
        width: window.innerWidth,
      }));
    }
  };

  handleCustomizer = (bool) => {
    this.setState({
      customizer: bool,
    });
  };

  componentDidMount() {
    this.mounted = true;
    let {
      app: {
        customizer: { theme, direction },
      },
    } = this.props;
    let pathname = window.location.pathname;
    if (this.mounted) {
      if (window !== "undefined") {
        window.addEventListener("resize", this.updateWidth, false);
      }
      if (this.collapsedPaths.includes(pathname)) {
        this.props.collapseSidebar(true);
      }

      let layout = theme;
      let dir = direction;
      if (dir === "rtl")
        document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
      else document.getElementsByTagName("html")[0].setAttribute("dir", "ltr");
      return layout === "dark"
        ? document.body.classList.add("dark-layout")
        : layout === "semi-dark"
          ? document.body.classList.add("semi-dark-layout")
          : null;
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let {
      app: {
        customizer: { theme, sidebarCollapsed },
      },
    } = this.props;
    let pathname = window.location.pathname;

    let layout = theme;
    if (this.mounted) {
      if (layout === "dark") {
        document.body.classList.remove("semi-dark-layout");
        document.body.classList.add("dark-layout");
      }
      if (layout === "semi-dark") {
        document.body.classList.remove("dark-layout");
        document.body.classList.add("semi-dark-layout");
      }
      if (layout !== "dark" && layout !== "semi-dark") {
        document.body.classList.remove("dark-layout", "semi-dark-layout");
      }

      // if (
      //   prevProps.app.customizer.sidebarCollapsed !==
      //   this.props.app.customizer.sidebarCollapsed
      // ) {
      //   this.setState({
      //     collapsedContent: sidebarCollapsed,
      //     sidebarState: sidebarCollapsed,
      //   });
      // }
      // if (
      //   prevProps.app.customizer.sidebarCollapsed ===
      //     this.props.app.customizer.sidebarCollapsed &&
      //   pathname !== prevProps?.location?.pathname &&
      //   this.collapsedPaths.includes(pathname)
      // ) {
      //   this.props.collapseSidebar(true);
      // }
      // if (
      //   prevProps.app.customizer.sidebarCollapsed ===
      //     this.props.app.customizer.sidebarCollapsed &&
      //   pathname !== prevProps?.location?.pathname &&
      //   !this.collapsedPaths.includes(pathname)
      // ) {
      //   this.props.collapseSidebar(false);
      // }
    }
  }

  handleCollapsedMenuPaths = (item) => {
    let collapsedPaths = this.collapsedPaths;
    if (!collapsedPaths.includes(item)) {
      collapsedPaths.push(item);
      this.collapsedPaths = collapsedPaths;
    }
  };
  toggleSidebarMenu = (collapsedValue = null) => {
    this.setState((prevState) => {
      const newCollapsed =
        collapsedValue !== null ? collapsedValue : !prevState.collapsedContent;

      return {
        collapsedContent: newCollapsed,
        sidebarState: newCollapsed ? false : prevState.sidebarState,
      };
    });
  };

  sidebarMenuHover = (val) => {
    this.setState({
      sidebarState: val,
    });
  };

  handleSidebarVisibility = () => {
    if (this.mounted) {
      if (window !== undefined) {
        window.addEventListener("resize", () => {
          if (this.state.sidebarHidden) {
            this.setState({
              sidebarHidden: !this.state.sidebarHidden,
            });
          }
        });
      }
      this.setState({
        sidebarHidden: !this.state.sidebarHidden,
      });
    }
  };

  componentWillUnmount() {
    this.mounted = false;
  }

  handleCurrentLanguage = (lang) => {
    this.setState({
      currentLang: lang,
    });
  };

  handleAppOverlay = (value) => {
    if (value.length > 0) {
      this.setState({
        appOverlay: true,
      });
    } else if (value.length < 0 || value === "") {
      this.setState({
        appOverlay: false,
      });
    }
  };

  handleAppOverlayClick = () => {
    this.setState({
      appOverlay: false,
    });
  };

  render() {
    let appProps = this.props.app?.customizer;
    let menuThemeArr = [
      "primary",
      "success",
      "danger",
      "info",
      "warning",
      "dark",
    ];
    let sidebarProps = {
      toggleSidebarMenu: this.props.collapseSidebar,
      toggle: this.toggleSidebarMenu,
      sidebarState: this.state.sidebarState,
      sidebarHover: this.sidebarMenuHover,
      sidebarVisibility: this.handleSidebarVisibility,
      visibilityState: this.state.sidebarHidden,
      activePath: this.props.match?.path,
      collapsedMenuPaths: this.handleCollapsedMenuPaths,
      activeTheme: appProps?.menuTheme,
      collapsed: this.state.collapsedContent,
      deviceWidth: this.state.width,
    };
    let navbarProps = {
      sidebarVisibility: this.handleSidebarVisibility,
      navbarColor: appProps?.navbarColor,
      navbarType: appProps?.navbarType,
    };

    let footerProps = {
      footerType: appProps?.footerType,
    };

    let customizerProps = {
      customizerState: this.state.customizer,
      handleCustomizer: this.handleCustomizer,
      changeMode: this.props.changeMode,
      changeNavbar: this.props.changeNavbarColor,
      changeNavbarType: this.props.changeNavbarType,
      changeFooterType: this.props.changeFooterType,
      changeMenuTheme: this.props.changeMenuColor,
      collapseSidebar: this.props.collapseSidebar,
      hideScrollToTop: this.props.hideScrollToTop,
      activeMode: appProps?.theme,
      activeNavbar: appProps?.navbarColor,
      navbarType: appProps?.navbarType,
      footerType: appProps?.footerType,
      menuTheme: appProps?.menuTheme,
      scrollToTop: appProps?.hideScrollToTop,
      sidebarState: appProps?.sidebarCollapsed,
    };

    return (
      <div
        className={classnames(
          `wrapper vertical-layout theme-${appProps?.menuTheme}`,
          {
            "menu-collapsed":
              this.state.collapsedContent === true && this.state.width >= 1200,
            "fixed-footer": appProps?.footerType === "sticky",
            "navbar-static": appProps?.navbarType === "static",
            "navbar-sticky": appProps?.navbarType === "sticky",
            "navbar-floating": appProps?.navbarType === "floating",
            "navbar-hidden": appProps?.navbarType === "hidden",
            "theme-primary": !menuThemeArr.includes(appProps?.menuTheme),
          },
        )}
      >
        <Sidebar {...sidebarProps} />
        <div
          className={classnames("app-content content", {
            "show-overlay": this.state.appOverlay === true,
          })}
          onClick={this.handleAppOverlayClick}
        >
          <Navbar {...navbarProps} />
          <div className="content-wrapper">{this.props.children}</div>
        </div>

        <Footer {...footerProps} />
        {appProps?.disableCustomizer !== true ? (
          <Customizer {...customizerProps} />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    app: state.customizer,
  };
};
export default connect(mapStateToProps, {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
})(VerticalLayout);
